var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"ScanInvoiceHIstoryGrid",attrs:{"model":_vm.getModel,"name":"Invoice Scanning","desc":"Line Item Entry","search-placeholder":"Scanned Invoices","fit-columns":"","search":true,"resizing":false,"footer":"","endpoint":_vm.api.$.admin.getInvoicesToBeScannedHistory,"alias":"InvoiceScanHistory","checkboxes":false,"tabs":_vm.tabs}},[_c('back',{attrs:{"slot":"back-action"},slot:"back-action"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05426d8f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/InvoiceScan/History.vue
// module id = /Dpy
// module chunks = 12